import { CountryType } from '../AddressForm.types';
import { utils as ejsUtils } from '@tangibleplay/ecommerce-js';

export const getRegions = (country: CountryType) =>
  ejsUtils.regions.regionsByCountry[country]?.regions;
